var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-tree-wrap"},[_c('div',{staticClass:"tree-scroll"},[_c('org-node',{attrs:{"node":_vm.treeRoot,"is-root":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }